<template>
  <v-row no-gutters class="button-tile-row">
    <v-col cols="12">
      <v-row class="button-tiles-row">
        <v-col
          class="button-tile-segment"
          cols="12"
          sm="6"
          md="4"
          lg="3"
          v-for="(tile, index) in tiles"
          :key="index"
        >
          <ButtonTile
            :imageUrl="tile.imageUrl"
            :title="tile.title"
            :description="tile.description"
            :simpleTiles="simpleTiles"
          ></ButtonTile>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  import ButtonTile from './ButtonTile.vue';

  export default {
    name: 'ButtonTiles',
    components: {
      ButtonTile,
    },
    props: {
      tiles: {
        required: true,
        default: [],
        type: Array,
      },
      simpleTiles: {
        default: false,
        type: Boolean,
      },
    },
  };
</script>

<style scoped lang="scss">
  .button-tiles-row {
    padding-left: 16px;
    padding-right: 16px;
    display: flex;
    justify-content: center;
    max-width: 98dvw;
    margin: 0;
    .col {
      padding: 0;
    }

    .button-tile-segment {
      display: flex;
      padding-left: 16px;
      padding-right: 16px;
    }
  }
  @media screen and (max-width: 959px) {
    .button-tiles-row {
      justify-content: flex-start !important;
    }
  }
</style>
